import { render, staticRenderFns } from "./prescriptionShow.vue?vue&type=template&id=39c30608&scoped=true"
import script from "./prescriptionShow.vue?vue&type=script&lang=js"
export * from "./prescriptionShow.vue?vue&type=script&lang=js"
import style0 from "./prescriptionShow.vue?vue&type=style&index=0&id=39c30608&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c30608",
  null
  
)

export default component.exports